import moment from 'moment'

export const isCheckboxSelected = (value) => value === '1'

export const isDateOfBirthBetween = (dateStr, minStr, maxStr) => {
  const min = Number(minStr)
  const max = Number(maxStr)
  const years = moment().diff(moment(dateStr, 'DD.MM.YYYY'), 'years')
  return years < min || years > max
}
